import React, { useState, useEffect } from 'react';
import { object, func, bool, string } from 'prop-types';
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage, useForm } from '@laramie/ui';
import { APIS } from '../../../config/apis';
import { useLista } from '../../hooks/useLista';
import { ServerRequest } from '../../../utils/apiweb';
import {TIPS} from "../../../consts/tips";

import { useFormErrors } from '../../hooks/useFormErrors';
import { FormError, FormLabel, InputFile, InputLista, Modal } from '../../common';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';

const PlantillaDocumentoModal = (props) => {

    //variables
    const entityInit = {
        id: 0,
        idTipoPlantillaDocumento: 0,
        Archivo_descripcion: '',
        Archivo_nombre: '',
        Archivo_path: ''
    };

    //hooks
    const [state, setState] = useState({
        loading: false,
        entity: entityInit,
        showInfo: false
    });    

    const mount = () => {

        if (props.id > 0) {
            FindPlantillaDocumento();
        }
   
        const unmount = () => {}
        return unmount;
    }
    useEffect(mount, []);

    const [, getRowLista ] = useLista({
        listas: ['TipoPlantillaDocumento'],
        onLoaded: (listas, isSuccess, error) => {
          if (!isSuccess) {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
          }
        },
        memo: {
          key: 'TipoPlantillaDocumento',
          timeout: 0
        }
    });

    const getDescTipoPlantillaDocumento = (id) => {
        const row = getRowLista('TipoPlantillaDocumento', id);
        return (row) ? row.nombre : '';
    }

    const [ formValues, formHandle, , formSet ] = useForm({
        idTipoPlantillaDocumento: 0,
        Archivo_nombre: '',
        Archivo_path: '',
        Archivo_descripcion: ''
    });

    const { errorOf, validate } = useFormErrors(getErrors);

    //handles
    const handleClickAceptar = () => {
        if (validate()) {
            if (props.id == 0) {
                AddPlantillaDocumento();
            }
            else {
                ModifyPlantillaDocumento();
            }
        };
    };
    const handleClickCancelar = () => {
        props.onDismiss();
    }

    const handleUploadArchivo = (filename, data) => {

        const callbackSuccess = (response) => {
          response.text()
          .then((path) => {
            formSet({
              ...formValues,
              Archivo_path: path,
              Archivo_nombre: filename
            });
          })
          .catch((error) => {
              const message = 'Error procesando respuesta: ' + error;
              ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
          });
        };
    
        const paramsHeaders = {
          "Content-Type": "application/octet-stream"
        };
        ServerRequest(
          REQUEST_METHOD.POST,
          paramsHeaders,
          true,
          APIS.URLS.FILE,
          null,
          data,
          callbackSuccess,
          callbackNoSuccess,
          callbackError,
          false
        );   
    }

    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
        .then((error) => {
            const message = error.message;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
            return {...prevState, loading: false};
            });
        });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }  

    // funciones
    function getErrors() {

        const errors = {};

        if (formValues.idTipoPlantillaDocumento <= 0) errors.idTipoPlantillaDocumento = VALIDATION_MESSAGE.REQUIRED_OPTION
        if (formValues.Archivo_descripcion.length <= 0) errors.Archivo_descripcion = VALIDATION_MESSAGE.REQUIRED
        if (formValues.Archivo_nombre.length <= 0) errors.Archivo_nombre = VALIDATION_MESSAGE.REQUIRED

        return errors;
    }   
    
    function FindPlantillaDocumento() {
    
        setState(prevState => {
          return {...prevState, loading: true};
        });
    
        const callbackSuccess = (response) => {
            response.json()
            .then((data) => {               
                setState(prevState => {
                  return {...prevState, loading: false, entity: data};
                });
                formSet({
                    idTipoPlantillaDocumento: data.idTipoPlantillaDocumento,
                    Archivo_descripcion: data.descripcion,
                    Archivo_nombre: data.nombre,
                    Archivo_path: data.path
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                  return {...prevState, loading: false};
                });
            });
        };
    
        const paramsUrl = `/${props.id}`;
    
        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.PLANTILLA_DOCUMENTO,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );
    
    }
    
    function AddPlantillaDocumento() {
        const method = REQUEST_METHOD.POST;
        const paramsUrl = null;
        SavePlantillaDocumento(method, paramsUrl);
    }
    
    function ModifyPlantillaDocumento() {
        const method = REQUEST_METHOD.PUT;
        const paramsUrl = `/${props.id}`;
        SavePlantillaDocumento(method, paramsUrl);
    }    

    function SavePlantillaDocumento(method, paramsUrl) {

        setState(prevState => {
          return {...prevState, loading: true};
        });
    
        const callbackSuccess = (response) => {
          response.json()
          .then((row) => {
            setState(prevState => {
                return {...prevState, loading: false};
            });
            props.onConfirm(row.id);
          })
          .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
              return {...prevState, loading: false};
            });
          });
        };
    
        const dataBody = {
                ...state.entity,              
                idTipoPlantillaDocumento: formValues.idTipoPlantillaDocumento,
                descripcion: formValues.Archivo_descripcion,
                nombre: formValues.Archivo_nombre,
                path: formValues.Archivo_path,
        };
    
        ServerRequest(
            method,
            null,
            true,
            APIS.URLS.PLANTILLA_DOCUMENTO,
            paramsUrl,
            dataBody,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );
    
    }

  return (
    <>

    <Modal
      size="md"
      title={`Plantilla documento: ${(props && props.id > 0) ?
                  getDescTipoPlantillaDocumento(state.entity.idTipoPlantillaDocumento) : "Nuevo"}`}
      tipName={TIPS.NAME.MODALS.PLANTILLA_DOCUMENTO_MODAL}
      onEscape={handleClickCancelar}
      body={(
            <div className="row">

                <div className="mb-3 col-12">
                    <FormLabel htmlFor="idTipoPlantillaDocumento" required>Tipo plantilla</FormLabel>
                    <InputLista
                        name="idTipoPlantillaDocumento"
                        placeholder=""
                        className={`form-control ${errorOf('idTipoPlantillaDocumento') ? 'is-invalid' : ''}`}
                        value={ formValues.idTipoPlantillaDocumento }
                        onChange={ formHandle }
                        disabled={props.disabled}
                        lista="TipoPlantillaDocumento"
                    />
                    <FormError message={errorOf('idTipoPlantillaDocumento')} />
                </div>
                <div className="mb-3 col-12">
                    <FormLabel htmlFor="Archivo_descripcion" required>Descripción</FormLabel>
                    <input
                        name="Archivo_descripcion"
                        type="text"
                        placeholder=""
                        className={`form-control ${errorOf('Archivo_descripcion') ? 'is-invalid' : ''}`}
                        value={ formValues.Archivo_descripcion }
                        onChange={ formHandle }
                        disabled={props.disabled}
                    />
                    <FormError message={errorOf('Archivo_descripcion')} />
                </div>
                <div className="mb-3 col-12">
                    <FormLabel htmlFor="Archivo_nombre" required>Archivo</FormLabel>
                    <InputFile
                        name="Archivo_nombre"
                        type="text"
                        placeholder="Click para adjuntar un archivo..."
                        className={`form-control ${errorOf('Archivo_nombre') ? 'is-invalid' : ''}`}
                        value={ formValues.Archivo_nombre }
                        onUpload={ handleUploadArchivo }
                        disabled={props.disabled}
                    />
                    <FormError message={errorOf('Archivo_nombre')} />
                </div>


            </div>
      )}
      footer={!props.disabled ? (<>
              <button className="btn btn-outline-primary" data-dismiss="modal" onClick={ (event) => handleClickCancelar() }>Cancelar</button>
              <button className="btn btn-primary" data-dismiss="modal" onClick={ (event) => handleClickAceptar() }>Aceptar</button>
      </>) : (
              <button className="btn back-button" data-dismiss="modal"onClick={ (event) => handleClickCancelar() }>Volver</button>
      )}
      footerClassName={props.disabled ? 'f-align' : ''}
    />

    </>
  );
}

PlantillaDocumentoModal.propTypes = {
    processKey: string.isRequired,
    disabled: bool,
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

PlantillaDocumentoModal.defaultProps = {
    disabled: false
};

export default PlantillaDocumentoModal;